import { useEffect, useState } from "react";
import { CseType_Db } from "../types/cse";
import API from "../utils/API";
import * as Auth from "../utils/Auth";

const useCseFirstdTurn = (cseId: number) => {
  const [cse, setCse] = useState<CseType_Db | null>(null);
  useEffect(() => {
    API.post(
      "/cseRouteCRUD",
      {
        cseParentId: cseId,
        path: "/getCseFirstTurn",
        module: "cse",
        token: Auth.getToken(),
      },
      (data: any) => {
        setCse(data.data);
      }
    );
  }, []);
  return cse;
};

export default useCseFirstdTurn;
